import { BalanceType } from '../models/Base';
import { PNGIconName } from './pngIcon';

// Define a subset type for currencies for ui
export type CurrencyType =
  | BalanceType.JoyPoint
  | BalanceType.Diamond
  | BalanceType.GameToken
  | BalanceType.CreationToken
  | StaminaType.GameStamina
  | StaminaType.CreationStamina;

export enum StaminaType {
  GameStamina = 'gameStamina',
  CreationStamina = 'creationStamina',
}

interface CurrencyDetails {
  icon: PNGIconName;
  displayName: string;
  notEnoughMessage: string;
}

const currencyDetails: Record<CurrencyType, CurrencyDetails> = {
  [BalanceType.JoyPoint]: {
    icon: 'JCoin',
    displayName: 'J Coins',
    notEnoughMessage: 'Not Enough J Coin!',
  },
  [BalanceType.Diamond]: {
    icon: 'Diamond',
    displayName: 'Diamonds',
    notEnoughMessage: 'Not Enough Diamond!',
  },
  [BalanceType.GameToken]: {
    icon: 'GameToken',
    displayName: 'Game Tokens',
    notEnoughMessage: 'Not Enough Game Token!',
  },
  [BalanceType.CreationToken]: {
    icon: 'CreationToken',
    displayName: 'Creation Tokens',
    notEnoughMessage: 'Not Enough Creation Token!',
  },
  [StaminaType.GameStamina]: {
    icon: 'GameStamina',
    displayName: 'Game Stamina',
    notEnoughMessage: 'Not Enough Game Stamina!',
  },
  [StaminaType.CreationStamina]: {
    icon: 'CreationStamina',
    displayName: 'Creation Stamina',
    notEnoughMessage: 'Not Enough Creation Stamina!',
  },
};

export const getCurrencyDetails = (
  balanceType: CurrencyType,
): CurrencyDetails => {
  return currencyDetails[balanceType];
};
